// REACT IMPORTS
import 'keen-slider/keen-slider.min.css'

// ABSOLUTE IMPORTS
import { LayoutContainer } from 'ui/layout/LayoutContainer'
import PoweredByHooplaIcon from 'components/HeaderVariant/HeaderV2/components/PoweredByHooplaIcon/PoweredByHooplaIcon'
import SubNavEmptyLink from './SubNavEmptyLink'
import type { Maybe } from 'types/hoopla'

type SubNavProps = {
  isLibraryBrandingEnabled?: boolean
  libraryBrandingColor?: Maybe<string>
  libraryName?: string
  isDarkMode: boolean
}

const SubNav = ({
  isLibraryBrandingEnabled,
  libraryBrandingColor,
  libraryName,
  isDarkMode,
}: SubNavProps) => {
  return (
    <section
      className="hidden bg-primary-blue-grey-light dark:bg-primary-blue-grey-dark sm:block"
      style={
        !isDarkMode && isLibraryBrandingEnabled && libraryBrandingColor
          ? { backgroundColor: libraryBrandingColor }
          : {}
      }>
      <div className="relative rounded-t-2xl border border-transparent bg-primary-background-light dark:bg-primary-background-dark">
        <LayoutContainer className="animate-pulse">
          <div className="-ml-2 flex flex-row items-center justify-between">
            <div className="overflow-hidden">
              <ul className="keen-slider pb-2.5 pt-2">
                <SubNavEmptyLink />
                <SubNavEmptyLink />
                <SubNavEmptyLink />
                <SubNavEmptyLink />
                <SubNavEmptyLink />
                <SubNavEmptyLink />
                <SubNavEmptyLink />
                <SubNavEmptyLink />
              </ul>
            </div>
            <div
              className="
                hidden whitespace-nowrap border-l border-l-stroke-med-light py-2 text-sm font-semibold text-text-1-light ltr:pl-4 rtl:pr-4
              dark:border-l-stroke-med-dark dark:text-text-1-dark
                lg-v2:flex
              ">
              <PoweredByHooplaIcon
                libraryName={libraryName}
                isLibraryBrandingEnabled={isLibraryBrandingEnabled}
                isDarkMode={isDarkMode}
              />
            </div>
          </div>
        </LayoutContainer>
      </div>
    </section>
  )
}

export default SubNav
